import React from "react";

export default function AccessCodeModal({
    code,
    setCode,
    codeError,
    setCodeError,
    redeem,
    redeeming,
    onClose,
}) {
    return (
        <div
            className="fixed inset-0 bg-black/50 z-[70] flex items-end sm:items-center justify-center px-3 pb-3 sm:p-6"
            onClick={onClose}
            data-testid="code-modal"
        >
            <div
                onClick={e => e.stopPropagation()}
                className="w-full sm:max-w-md bg-cream border border-burgundy/20"
            >
                <div className="px-6 pt-6 pb-3 border-b border-burgundy/15">
                    <div className="text-[10px] tracking-[0.32em] uppercase text-gold-deep">Access</div>
                    <h3 className="mt-1 font-display text-2xl text-burgundy">
                        <span className="italic">Enter your</span> access code
                    </h3>
                    <p className="mt-2 text-sm text-ink-muted">
                        Friends, family & demo codes unlock the full experience without payment.
                    </p>
                </div>
                <div className="px-6 py-4 space-y-3">
                    <input
                        data-testid="code-input"
                        type="text"
                        autoFocus
                        value={code}
                        onChange={e => { setCode(e.target.value); setCodeError(null); }}
                        onKeyDown={e => { if (e.key === "Enter") redeem(); }}
                        placeholder="e.g. EVERAFTER-FF"
                        className="w-full bg-cream-soft border border-burgundy/20 focus:border-burgundy py-3 px-4 font-mono text-lg uppercase tracking-widest text-burgundy focus:outline-none"
                    />
                    {codeError && (
                        <div data-testid="code-error" className="text-xs text-burgundy bg-rose/20 border border-burgundy/20 px-3 py-2">
                            {codeError}
                        </div>
                    )}
                </div>
                <div className="px-6 py-4 border-t border-burgundy/15 flex gap-2">
                    <button
                        onClick={onClose}
                        className="flex-1 border border-burgundy/30 text-burgundy uppercase text-[11px] tracking-[0.22em] py-3"
                    >
                        Cancel
                    </button>
                    <button
                        data-testid="code-redeem-btn"
                        onClick={redeem}
                        disabled={redeeming || !code.trim()}
                        className="flex-1 bg-burgundy text-cream uppercase text-[11px] tracking-[0.22em] py-3 hover:bg-burgundy-deep disabled:opacity-50"
                    >
                        {redeeming ? "Checking…" : "Unlock"}
                    </button>
                </div>
            </div>
        </div>
    );
}
